import { render, staticRenderFns } from "./InstantAlertConfiguration.vue?vue&type=template&id=6ef8bb4a"
import script from "./InstantAlertConfiguration.vue?vue&type=script&lang=js"
export * from "./InstantAlertConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports